import React from "react";
import "./IpSummary.scss";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";

function ResourceSection({ projectData }) {
  const reports = projectData?.data?.resourceSection?.uploadedReports || [];
  const documents = projectData?.data?.resourceSection?.uploadedDocuments || [];

  return (
    <div className="resourceSection">
      <h2 className="ipCardName">Resource Section</h2>
      {/* Reports and documents 50/50 rather than two flex:1 columns that
          collapsed to different widths depending on their content. */}
      <div className="resourceReport">
        <div className="resourceReportCard">
          <h3 className="ipCardListTitle">Last 6 Reports Uploaded</h3>
          <div className="resourceReportList">
            {reports.length === 0 && (
              <span className="ipCardsEmpty">No reports uploaded.</span>
            )}
            {reports.slice(0, 6).map((report, index) => (
              <div key={index} className="reportItem">
                <div className="ipCardTextName">
                  <span className="boldText">{report.name}</span>
                </div>
                <div className="ipCardTextName">
                  Status: <span className="boldText">{report.reportStatus}</span>
                </div>
                <div className="ipCardTextName">
                  Location: <span className="boldText">{report.location}</span>
                </div>
                <div className="ipCardTextName">
                  Date:{" "}
                  <span className="boldText">
                    {formatDate(report.createdDate)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="resourceReportCard">
          <h3 className="ipCardListTitle">Last 6 Documents Uploaded</h3>
          <div className="resourceReportList">
            {documents.length === 0 && (
              <span className="ipCardsEmpty">No documents uploaded.</span>
            )}
            {documents.slice(0, 6).map((document, index) => (
              <div key={index} className="reportItem">
                <span className="ipCardTextName">
                  <span className="boldText">{document.fileName}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResourceSection;
